interface Props {
    className?: string
    FillColor?: string
}

export default function Sort({className, FillColor}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M7.50001 2.37507C7.50001 2.20939 7.63433 2.07507 7.80001 2.07507C8.46276 2.07507 9.00001 2.61233 9.00001 3.27507V19.5448L12.0076 16.5372C12.1248 16.42 12.3147 16.42 12.4319 16.5372C12.9005 17.0058 12.9005 17.7656 12.4319 18.2343L9.08846 21.5777C8.62543 22.0407 7.87471 22.0407 7.41168 21.5777L4.06827 18.2343C3.59964 17.7656 3.59964 17.0058 4.06827 16.5372C4.18543 16.42 4.37538 16.42 4.49253 16.5372L7.50001 19.5447V2.37507Z"
                fill={FillColor} />
            <path
                d="M19.5074 7.64336L16.4999 4.63588V21.2751C16.4999 21.4408 16.3656 21.5751 16.1999 21.5751C15.5372 21.5751 14.9999 21.0379 14.9999 20.3751V4.63576L11.9923 7.64336C11.8752 7.76051 11.6852 7.76051 11.5681 7.64336C11.0995 7.17473 11.0995 6.41493 11.5681 5.9463L14.9115 2.60289C15.3745 2.13986 16.1252 2.13986 16.5883 2.60289L19.9317 5.9463C20.4003 6.41493 20.4003 7.17473 19.9317 7.64336C19.8145 7.76051 19.6246 7.76051 19.5074 7.64336Z"
                fill={FillColor} />
        </svg>
    )
}
